module.exports = __webpack_public_path__ + "img/red_001.a4d82bc8.png";